/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EmailLog } from './EmailLog';
import type { PerStepComplete } from './PerStepComplete';

export type InvoiceTaskProperties = {
    invoice_id?: number;
    email_logs?: Array<EmailLog>;
    prepare_notes?: string;
    dispute_notes?: string;
    dispute_status?: InvoiceTaskProperties.dispute_status;
    invoice_prepared?: PerStepComplete;
    invoice_sent?: PerStepComplete;
    email_sending_status?: InvoiceTaskProperties.email_sending_status;
};

export namespace InvoiceTaskProperties {

    export enum dispute_status {
        NO_DISPUTE = 'no_dispute',
        IN_DISPUTE = 'in_dispute',
        RESOLVED = 'resolved',
    }

    export enum email_sending_status {
        EMAIL_SENDING = 'email_sending',
        EMAIL_FAILED = 'email_failed',
        EMAIL_SENT = 'email_sent',
    }


}

